exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".source-logo-dashboard{float:left;width:24px;height:24px;margin-right:5px;opacity:.8}", ""]);

// exports
